export const normalizeVideoUiStatus = status => {
  const normalized = String(status || '').trim().toLowerCase().replace('-', '_')
  if (['queued', 'pending'].includes(normalized)) return 'queued'
  if (['running', 'processing'].includes(normalized)) return 'in_progress'
  if (normalized === 'succeeded') return 'completed'
  if (['canceled', 'unknown'].includes(normalized)) return 'failed'
  return normalized || 'in_progress'
}

// Wan exposes task stages, not a measured percentage. Keep its processing
// animation visible without presenting legacy synthetic 0/50 as progress.
export const hasVideoProgress = video => !['wan3', 'wan3-cd'].includes(video.platform)
  && video.progress != null && video.progress !== '' && Number.isFinite(Number(video.progress))
  && Number(video.progress) >= 0 && Number(video.progress) <= 100

// Only WAN3-CD callers use this label: ordinary WAN3 retains its existing flow.
export const wan3CdWorkflowLabel = (workflowStatus, status) => {
  if (workflowStatus === 'CANCELLED') return '已取消'
  if (['completed', 'failed'].includes(normalizeVideoUiStatus(status))) return ''
  if (workflowStatus === 'WAITING_SLOT') return '等待生成名额'
  if (workflowStatus === 'SUBMITTING') return '正在提交生成'
  if (workflowStatus === 'UNCERTAIN') return '正在确认提交结果'
  if (workflowStatus === 'SUBMITTED') return normalizeVideoUiStatus(status) === 'queued' ? '上游排队中' : '生成中'
  return ''
}
